import { getCartesianCoordinateSystem } from './coordinateSystem';
export const getGrid = (api) => {
    return getCartesianCoordinateSystem(api).getRect();
};
